import isMatch from 'lodash.ismatch';

export function isObjectMatch(obj: Record<string, unknown>, source: Record<string, unknown>) {
  return isMatch(obj, source);
}
